import { isColorMap } from "@/utility/typeGuard";
import { unsafeGetColormapByName } from "@/utility/unsafeGetColormapByName";
import type { WmsLayer } from "@mm/metx-workbench.meteomatics.com";

export function normalizeWmsColormapOnParameterChange(
  layer: Pick<WmsLayer, "parameter_unit" | "color_map">,
  patch: Partial<Pick<WmsLayer, "parameter_unit" | "color_map">>,
): Partial<Pick<WmsLayer, "parameter_unit" | "color_map">> {
  if (typeof patch.parameter_unit !== "string") {
    return patch;
  }

  const defaultColormap = unsafeGetColormapByName("", patch.parameter_unit);
  const nextColorMap = patch.color_map ?? layer.color_map ?? "";
  const requestedColorMap = nextColorMap !== "" ? nextColorMap : defaultColormap;

  if (isColorMap(requestedColorMap)) {
    return patch;
  }

  return {
    ...patch,
    color_map: defaultColormap,
  };
}
